import styled from "styled-components"
import {ButtonLink} from "@irati/ui/src/Link"

// Custom styles for Zip branding
const rubik = "Rubik, sans-serif"
const rubikBold = "RubikBold, sans-serif"
const zipHeaderColor = "#21285e"
const zipBodyColor = "#3f3f47"
const zipModalButtonColor = "#1153EC"

export const ZipLogoModal = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 20%;
  padding-top: 40px;
`

export const ZipH2 = styled.h2`
  font-family: ${rubik};
  font-size: 30px;
  margin-bottom: 5px;
  text-align: center;
  color: ${zipHeaderColor};
`

export const ZipH3 = styled.h3`
  font-family: ${rubikBold};
  color: ${zipHeaderColor};
  font-size: 25px;
  text-align: center;
  line-height: 30px;
`

export const ZipBody = styled.p`
  font-family: ${rubik};
  color: ${zipBodyColor};
  font-weight: normal;
  text-align: center;
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 30px;
`

export const ZipImage = styled.img`
  display: block;
  height: 30px;
  width: 40px;
  padding-bottom: 6px;
`

export const ZipModalImage = styled.img`
  margin-bottom: 5px;
  margin-top: 40px;
  margin-right: 15px;
`

export const ZipModalButtonLink = styled(ButtonLink)`
  background-color: ${zipModalButtonColor};
  border-color: ${zipModalButtonColor};

  &:hover,
  &:active,
  &:focus {
    background-color: ${zipModalButtonColor};
    border-color: ${zipModalButtonColor};
  }
`
